
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SignupForm from './auth/SignupForm';
import LoginForm from './auth/LoginForm';

const AuthForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  
  return (
    <div className="w-full max-w-md mx-auto animate-fadeIn">
      <Tabs defaultValue="signup" className="w-full">
        <TabsList className="grid grid-cols-2 mb-8">
          <TabsTrigger value="signup" className="text-lg">Sign Up</TabsTrigger>
          <TabsTrigger value="login" className="text-lg">Login</TabsTrigger>
        </TabsList>
        
        <TabsContent value="signup">
          <SignupForm 
            isSubmitting={isSubmitting} 
            setCaptchaVerified={setCaptchaVerified}
            captchaVerified={captchaVerified}
          />
        </TabsContent>
        
        <TabsContent value="login">
          <LoginForm isSubmitting={isSubmitting} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AuthForm;
